import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';

import config from 'config';
import http from './http';
import { v4 as uuidv4 } from 'uuid';
import mock from '../../data/mock/token.json';

export const useHttpAuthInterceptors = (): void => {
  const { instance, accounts } = useMsal();

  const getForceRefreshToken = (exp: number): boolean => {
    const nowTimestamp = Math.floor(new Date().getTime() / 1000);
    const diff = exp - nowTimestamp;
    return Math.floor(diff / 60) <= 10;
  };

  useEffect(() => {
    const reqInterceptor = http.addRequestInterceptor(
      async (setting: any) => {
        try {
          if (config.AUTH.ENABLED === 'true') {
            let forceRefresh = false;
            if (accounts.length >= 1) {
              forceRefresh = getForceRefreshToken(
                Number(accounts[0]?.idTokenClaims?.exp)
              );
            }
            const result = await instance?.acquireTokenSilent({
              scopes: [config.AUTH.SCOPES || 'User.Read'],
              account: accounts[0],
              forceRefresh
            });
            const token: string = result.idToken;
            if (token !== '' && setting.headers != null) {
              setting.headers.Authorization = `Bearer ${token}`;
            }
          } else {
            setting.headers.Authorization = `Bearer ${mock.token}`;
          }
        } catch (error) {
          console.error(error);
        } finally {
          setting.headers['request-id'] = uuidv4();
          setting.headers['app-version'] = config.APP.VERSION;
        }
        return setting;
      },
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      async (error: unknown) => await Promise.reject(error)
    );

    return () => {
      http.removeRequestInterceptor(reqInterceptor);
    };
  }, [instance, accounts]);
};
